import { Typography } from "@mui/material";
import React, { useMemo } from "react";

import { type ManagerFragment, TicketCreatorEnum } from "src/graphql/generated/types";

const SENDER_LABEL: Partial<Record<TicketCreatorEnum, string>> = {
  [TicketCreatorEnum.Manager]: "VOTRE GESTIONNAIRE",
  [TicketCreatorEnum.MiddleOffice]: "SERVICE CLIENT",
};

type Props = {
  associate?: ManagerFragment | null;
  createdBy: TicketCreatorEnum;
};

export const HeaderDescription = ({ associate, createdBy }: Props) => {
  const description = useMemo(() => {
    if (createdBy === TicketCreatorEnum.Client) {return "VOTRE MESSAGE";}
    const senderLabel = SENDER_LABEL[createdBy];

    if (!senderLabel) {return "";}

    const branchName = associate?.branch?.commercialName || "";

    return `${senderLabel}${branchName ? ` - ${branchName}` : ""}`;
  }, [associate, createdBy]);

  return <Typography sx={{ fontWeight: "bold" }}>{description}</Typography>;
};
